import ScalarIconScroll_vue_vue_type_script_setup_true_lang_default from "./ScalarIconScroll.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconScroll.vue
var ScalarIconScroll_default = ScalarIconScroll_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconScroll_default as default };

//# sourceMappingURL=ScalarIconScroll.js.map